import { useGlobalStore } from "@/store/GlobalStore";
import {
  CardListContent,
  PictureRechargeGiftCard,
  PictureRechargeGiftCardList,
  PictureRechargeGiftWrapper,
} from "./atom";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { RechargeTypeCode, Whether } from "project-config/constants";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";
import { useEffect, useState } from "react";
import { accSub } from "project-config/utils/acc";
import {
  RightIcon,
  LeftIcon,
  RightDarkIcon,
  LeftDarkIcon,
  CardCouponIcon,
  CardMemberIcon,
  GiftRightIcon,
  GiftLeftIcon,
} from "../../icons";
import { useClientTopUpStore } from "../../store";
import {
  presentAmountCalculate,
  rulesContentList,
} from "@/components/top-up/help/activityUtil";
import { useScrollCard } from "./hooks/useScrollCard";
import { BindActivityInfo } from "@/components/top-up/types";
import RuleModal from "../rule-modal";
import {
  CardGift,
  CommonCornerMark,
  GiftText,
  ActivityRuleAndCoupon,
} from "../../atom";
import { NewUserWelfare } from "../new-user-welfare";
import { useLocation } from "react-router-dom";
import RechargeVoucherModal from "../recharge-voucher-modal";

export function PictureRechargeGift({
  activityInfo,
}: {
  activityInfo: BindActivityInfo;
}) {
  const { userProperty } = useUserPropertyStore();
  const { userCumulative } = useGlobalStore();
  const {
    rechargeAmount,
    setRechargeAmount,
    rechargeSecondActiveName,
    isCheckCard,
    setIsCheckCard,
  } = useClientTopUpStore();
  const location = useLocation();
  const routeTheme = new URLSearchParams(location.search).get("theme");

  const getRechargeAmount = (amount: number) => {
    if (activityInfo.rechargeType === RechargeTypeCode.SumRecharge) {
      const amountSum = accSub(amount || 0, userCumulative);
      return amountSum > 4 ? amountSum : 5;
    } else {
      return amount;
    }
  };

  const priceList = activityInfo.activityDetail.map((item) =>
    getRechargeAmount(item.amount ?? 0)
  );

  const [openActivityRuleDrawer, setOpenActivityRuleDrawer] = useState(false);
  const { wrapperRef, isLeftHidden, isRightHidden, scrollRight, scrollLeft } =
    useScrollCard();

  useEffect(() => {
    if (rechargeSecondActiveName === "client-second-tab-first-recharge") return;
    setRechargeAmount(priceList[0]);
    setIsCheckCard(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rechargeSecondActiveName]);

  return (
    <PictureRechargeGiftWrapper>
      <ActivityRuleAndCoupon>
        <RuleModal
          type="recharge"
          ruleList={rulesContentList(activityInfo, true)}
          open={openActivityRuleDrawer}
          setRuleOpen={(val) => {
            setOpenActivityRuleDrawer(val);
          }}
        />
        <RechargeVoucherModal />
      </ActivityRuleAndCoupon>
      {userProperty.picRechargeOver === Whether.No && <NewUserWelfare />}
      <CardListContent>
        {activityInfo.activityDetail.length > 4 &&
          !isLeftHidden &&
          (routeTheme === "dark" ? (
            <LeftDarkIcon
              onClick={scrollLeft}
              className="scroll-button left-button"
            />
          ) : (
            <LeftIcon
              onClick={scrollLeft}
              className="scroll-button left-button"
            />
          ))}
        <div className="card-list-wrapper" ref={wrapperRef}>
          <PictureRechargeGiftCardList className="cards-wrapper">
            {activityInfo.activityDetail.map((item, i) => {
              const price = priceList[i];
              const isGiftVip = !!item.vipPresentAmount;
              const isGiftCoupon = !!item.presentAmount;
              const isCheckedCard =
                Number(rechargeAmount) === price && isCheckCard;
              return (
                <PictureRechargeGiftCard
                  isActive={isCheckedCard}
                  onClick={() => {
                    setRechargeAmount(price);
                    setIsCheckCard(true);
                  }}
                  key={item.id}
                >
                  {item.iconWord && item.iconWord !== "" && (
                    <CommonCornerMark>{item.iconWord}</CommonCornerMark>
                  )}
                  <div className="price-wrapper">
                    <span className="symbol">¥</span>
                    <span className="price">{price}</span>
                  </div>
                  <GiftText isActive={isCheckedCard} id="222">
                    <GiftRightIcon
                      fill={routeTheme === "dark" ? "#4C9EFE" : "#C0DCFF"}
                    />
                    <span>赠送</span>
                    <GiftLeftIcon
                      fill={routeTheme === "dark" ? "#4C9EFE" : "#C0DCFF"}
                    />
                  </GiftText>
                  {isGiftCoupon && (
                    <CardGift isActive={isCheckedCard}>
                      {isCheckedCard ? (
                        <CardCouponIcon className="is-check-card" />
                      ) : (
                        <CardCouponIcon />
                      )}
                      <span>
                        ¥
                        {presentAmountCalculate(
                          activityInfo,
                          price,
                          item.presentAmount
                        ) ?? 0}
                        &nbsp;
                        {couponTypeTranslate(item.couponType ?? 0)}
                      </span>
                    </CardGift>
                  )}
                  {isGiftVip && (
                    <CardGift isActive={isCheckedCard}>
                      {isCheckedCard ? (
                        <CardMemberIcon className="is-check-card" />
                      ) : (
                        <CardMemberIcon />
                      )}
                      <span>会员&nbsp;{item.vipPresentAmount}个月</span>
                    </CardGift>
                  )}
                </PictureRechargeGiftCard>
              );
            })}
          </PictureRechargeGiftCardList>
        </div>
        {activityInfo.activityDetail.length > 4 &&
          !isRightHidden &&
          (routeTheme === "dark" ? (
            <RightDarkIcon
              onClick={scrollRight}
              className="scroll-button right-button"
            />
          ) : (
            <RightIcon
              onClick={scrollRight}
              className="scroll-button right-button"
            />
          ))}
      </CardListContent>
    </PictureRechargeGiftWrapper>
  );
}
